import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { RadixDialog } from '@jotta/ui/RadixDialog'
import type { RadixModalProps } from '@jotta/ui/RadixModal'
import { RadixModal } from '@jotta/ui/RadixModal'

export interface EmptyTrashDialogProps extends RadixModalProps {
  onConfirm: () => void
}
export const EmptyTrashDialog = ({
  onClose,
  onConfirm,
  ...props
}: EmptyTrashDialogProps) => {
  return (
    <RadixModal onClose={onClose} {...props}>
      <RadixDialog
        onClose={onClose}
        title={t`Trash`}
        smallTitle={t`Permanently delete`}
        buttons={[
          {
            action: onConfirm,
            label: t`Permanently delete`,
            type: 'destructive',
          },
          {
            action: 'close',
            label: t`Cancel`,
            type: 'outline',
          },
        ]}
      >
        <Trans>
          Are you sure you want to remove all the files in your trash? This
          operation can not be undone.
        </Trans>
      </RadixDialog>
    </RadixModal>
  )
}
